module.exports = "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiPjxkZWZzPjxzdHlsZS8+PC9kZWZzPjxwYXRoIGQ9Ik00NjMuMyA5NTguM1Y3NzIuMUgyMjguOHYtNzcuNWgyMzQuNXYtODAuNUgyMjguOHYtODMuNUg0MjBMMTkxLjUgMTI4aDExMy43TDQ2OSA0MjAuNmMxOC4yIDMzLjQgMzIuNCA2Mi40IDQyLjcgODYuOSA5LTE5LjggMjQuNi01MC41IDQ2LjgtOTIuMUw3MTMuOSAxMjhoMTIwLjhMNjA1LjUgNTMwLjZoMTkyLjl2ODMuNUg1NjQuOXY4MC41aDIzMy41djc3LjVINTY0Ljl2MTg2LjJINDYzLjN6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/money.svg
// module id = ig9B
// module chunks = 72